import moment from 'jalali-moment';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import endpoints from '../../../config/endpoints';
import restApi from '../../../services/restApi';
import tools from '../../../utils/tools';

const Info = ({ form, setForm }) => {
  const [users, setUsers] = useState([]);

  // `form.price` is the pre-discount product total and `form.discountPrice` is
  // the total after product-level discounts (OrderService.calculatePrice), so
  // the discount line is the gap between the two — not discountPrice itself.
  const total = Number(form?.price) || 0;
  const discounted = Number(form?.discountPrice) || total;
  const deliveryPrice = Number(form?.delivery?.price) || 0;
  const discount = Math.max(0, total - discounted);
  // the flat discount the operator types in; it is capped at the goods total so
  // the payable figure can never go negative while they are still typing
  const adminDiscount = Math.min(Number(form?.adminDiscount) || 0, discounted);
  const payable = Math.max(0, discounted - adminDiscount) + deliveryPrice;

  const fetchData = async (query) => {
    const res = await restApi(endpoints.user.index).get({ phoneNumber: query, 'relations[]': ['userCars'] });

    setUsers(res.data);
  };

  useEffect(() => {
    const user = users.find(e => e.phoneNumber == form?.user?.phoneNumber);
    if (form?.user?.phoneNumber && user){
      setForm(prev => ({ ...prev, user: user }))
    }
  }, [form?.user?.phoneNumber]);
  
  return (
    <section className="topRow">
      <div className="infoSection">
        <h1 className="dashBoardTitle">اطلاعات کاربر</h1>
        <div className="userInfoContainer">
          <label className="sideBarTitle">نام</label>
          <input className="editProductInput" value={form?.user?.name || ''} onChange={(input) => {
            setForm(prev => {
              const user = prev.user || {};

              user.name = input.target.value

              return { ...prev, user: user }
            })
          }} />
          <label className="sideBarTitle">نام خانوادگی</label>
          <input className="editProductInput" value={form?.user?.lastName || ''} onChange={(input) => {
            setForm(prev => {
              const user = prev.user || {};

              user.lastName = input.target.value

              return { ...prev, user: user }
            })
          }} />
          <label className="sideBarTitle">شماره تلفن</label>
          <input className="editProductInput" list="phoneNumber" value={form?.user?.phoneNumber || ''} onChange={(input) => {
            input.target.value.length > 3 && fetchData(input.target.value);

            setForm(prev => {
              const user = prev.user || {};

              user.phoneNumber = input.target.value

              return { ...prev, user: user }
            })
          }} />
          <datalist id="phoneNumber" >
            {users.map(e => <option value={e.phoneNumber} >{[e.phoneNumber, e.name, e.lastName].filter(Boolean).join(' ')}</option>)}
          </datalist>
        </div>
      </div>

      <div className="infoSection">
        <h1 className="dashBoardTitle">مجموع فاکتور</h1>
        <div className="userInfoContainer">
           <span className="factorHeader">
             <p>{moment(form?.createdAt).format('jYYYY/jMM/jDD')}</p>
           </span>
          <span className="billItems dashboardBill">
            <h3 className="billItem">مبلغ سفارش</h3>
            <div className="pricePart">
              <h1 className="billPrice">{tools.formatPrice(total)}</h1>
            </div>
          </span>
          <span className="billItems dashboardBill">
            <h3 className="billItem">هزینه ارسال</h3>
            <div className="pricePart">
              <h1 className="billPrice">{tools.formatPrice(deliveryPrice)}</h1>
            </div>
          </span>
          <span className="billItems dashboardBill">
            <h3 className="billItem">تخفیف</h3>
            <div className="pricePart">
              <h1 className="billPrice">{tools.formatPrice(discount)}</h1>
            </div>
          </span>
          <span className="billItems dashboardBill">
            <h3 className="billItem">تخفیف دستی</h3>
            <div className="pricePart">
              <input
                className="persianName billDiscountInput"
                value={tools.formatPriceToStr(Number(form?.adminDiscount) || 0)}
                onChange={(input) =>
                  setForm(prev => ({
                    ...prev,
                    adminDiscount: tools.formatStrToPrice(input.target.value),
                  }))
                }
              />
            </div>
          </span>
          <span className="billItems dashboardBill">
            <h3 className="billItem">مالیات</h3>
            <div className="pricePart">
              <h1 className="billPrice">0%</h1>
            </div>
          </span>
          <hr className="dashedBill"/>
          <span className="billItems dashboardBill">
            <h3 className="billItem">مبلغ قابل پرداخت</h3>
            <div className="pricePart">
              <h1 className="tablePrice1"> تومان {tools.formatPrice(payable)}</h1>
            </div>
          </span>
        </div>
      </div>
    </section>
  )
};

export default Info;
